module.exports = __webpack_public_path__ + "static/img/6751_phase_function_Paper_PointsHejduk_Prediction.3637066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6751_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SBj5
// module chunks = 0